namespace SorAraBul.Administration {
    export class PurchasePackagesColumns {
        static columnsKey = 'Administration.PurchasePackages';
    }
}
